// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__32KEf","title":"Info_title__3-2i2","links":"Info_links__2kzLb","link":"Info_link__3TiSt","logo":"Info_logo__20VuH"};